import { motion } from 'framer-motion'
import clsx from 'clsx'
import { WidgetHeader } from 'components/WidgetHeader'
import { ChatDetail } from 'components/chats/ChatDetail'
import { WidgetKeypad } from 'components/WidgetKeypad'
import { useSelector } from 'react-redux'
import { selectChatId } from 'store/messages'
import { ChatsList } from 'components/chats/ChatsList'
import { WidgetModal } from 'components/WidgteModal'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { WidgetFileUploadModal } from 'components/WidgteFileUploadModal'
export const WidgetContent = () => {
  const chatId = useSelector(selectChatId)
  const { isAppMode } = useGetBotMode()

  if (isAppMode) {
    return (
      <div
        className={clsx(
          'tw-xs:w-full tw-fixed tw-bottom-0 tw-flex tw-h-[100%] tw-w-[100vw] tw-flex-col tw-rounded-5xl tw-mt-3 tw-font-lato tw-bg-primary-500',
        )}
        key="widget"
      >
        <WidgetHeader />
        <>
          {!chatId && (
            <>
              <ChatsList />
            </>
          )}
          {!!chatId && (
            <>
              <ChatDetail />
              <WidgetKeypad />
            </>
          )}
          <WidgetModal />
          <WidgetFileUploadModal />
        </>
      </div>
    )
  }

  return (
    <motion.div
      className={clsx(
        'tw-ring-black-5 tw-xs:right-0 tw-xs:w-full tw-fixed tw-bottom-5 tw-right-5 tw-z-50 tw-flex tw-w-[400px] tw-max-w-[90vw] tw-h-[calc(99vh-4.8rem)] tw-max-h-[40rem] tw-flex-col tw-rounded-5xl tw-bg-primary-500 tw-font-lato tw-shadow-lg',
      )}
      animate={{ y: -60 }}
      exit={{ opacity: 0 }}
      transition={{ type: 'spring', stiffness: 100 }}
    >
      <WidgetHeader />
      {!chatId && (
        <>
          <ChatsList />
        </>
      )}
      {!!chatId && (
        <>
          <ChatDetail />
          <WidgetKeypad />
        </>
      )}
      <WidgetFileUploadModal />
      <WidgetModal />
    </motion.div>
  )
}
